import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CookiesSettings } from '@jissu-public/shared/model';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  cookiesSettings: CookiesSettings = {
    essential: true,
    analytics: false,
    preference: false,
    showBanner: true,
    send: false,
  };

  private cookiesSettingsBehaviorSubject = new BehaviorSubject<CookiesSettings>(this.cookiesSettings);

  constructor() {
    const cookiesSettings = localStorage.getItem('cookiesSettings');
    if (cookiesSettings) {
      this.cookiesSettings = JSON.parse(cookiesSettings);
      this.cookiesSettingsBehaviorSubject.next(this.cookiesSettings);
    } else {
      localStorage.setItem('cookiesSettings', JSON.stringify(this.cookiesSettings));
    }
  }

  cookiesSettings$(): BehaviorSubject<CookiesSettings> {
    return this.cookiesSettingsBehaviorSubject;
  }

  saveCookiesSettings(cookiesSettings: CookiesSettings) {
    this.cookiesSettings = cookiesSettings;
    localStorage.setItem('cookiesSettings', JSON.stringify(this.cookiesSettings));
    this.cookiesSettingsBehaviorSubject.next(this.cookiesSettings);
  }
}
